module.exports = __webpack_public_path__ + "media/images/countryrect/ee-68688e8165b8dbd99258af7f49f69136.svg";